/** Mutable ref-box carrying completion/hover data into the editor.
 *
 * The wrapper mutates `current` whenever schemas/blocks/extras change, so
 * late-arriving data never forces an editor rebuild or reconfiguration —
 * completion and hover sources read the box at query time.
 * No @codemirror imports — shared between the sync wrapper and the async core.
 */
import type { MergedPathEntry } from './schemaPaths';
import type { BlockCompletionItem, ContextSchemaSource, ExtraCompletion } from './types';

export interface CompletionData {
  /** Merged schema paths (dotted path → merged entry). */
  paths: Map<string, MergedPathEntry>;
  /** Labels of the schema sources, for "Available in: …" hover hints. */
  sourceLabels: Map<string, string>;
  blocks: BlockCompletionItem[];
  extra: ExtraCompletion[];
}

export interface CompletionDataBox {
  current: CompletionData;
}

export function emptyCompletionData(): CompletionData {
  return { paths: new Map(), sourceLabels: new Map(), blocks: [], extra: [] };
}

export function sourceLabelsOf(sources: ContextSchemaSource[]): Map<string, string> {
  return new Map(sources.map((s) => [s.id, s.label ?? s.id]));
}
